/* The pre-trip document: A4 pages on paper, a stack of sheets on screen. Light only. */
.doc {
  padding: var(--dimension-space-4) var(--dimension-space-5) var(--dimension-space-8);
}
.bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--dimension-space-4);
  max-width: 210mm;
  margin: 0 auto var(--dimension-space-4);
}
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.page {
  display: grid;
  align-content: start;
  gap: var(--dimension-space-3);
  max-width: 210mm;
  min-height: 297mm;
  margin: 0 auto var(--dimension-space-4);
  padding: 16mm;
  box-sizing: border-box;
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.cover {
  align-content: center;
  border-top: var(--dimension-line-accent) solid var(--color-surface-signal);
}
.plain {
  margin: 0;
  padding: 0;
  list-style: none;
}
.dayHead {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-3);
  padding-bottom: var(--dimension-space-2);
  border-bottom: var(--dimension-line-control) solid var(--color-text-primary);
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table td {
  padding: var(--dimension-space-2) var(--dimension-space-2) var(--dimension-space-2) 0;
  vertical-align: top;
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.code {
  text-align: right;
  white-space: nowrap;
}
.local {
  margin-left: var(--dimension-space-2);
}
.note {
  display: grid;
  gap: var(--dimension-space-1);
}
.pre {
  margin: 0;
  white-space: pre-wrap;
}
@media print {
  @page {
    size: A4;
    margin: 0;
  }
  .bar {
    display: none;
  }
  .doc {
    padding: 0;
  }
  .page {
    margin: 0;
    border: 0;
    break-after: page;
  }
}
